export enum PackingInfoStatusType {
  NotPacked = "NotPacked",
  InProcess = "InProcess",
  Packed = "Packed"
}
